import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { makeStyles, withTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'; 
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Dialog from '@material-ui/core/Dialog';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import MonitoringsImage from '../monitoringsImage/monitoringsImage';

import MyWindowPortal from '../monitoringsPhotos/myWindowPortal';

import { to7digitals } from '../../utils/shared';
import { Hidden } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'block',
    maxWidth: '50vw', 
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    overflowX: 'hidden',
    margin: '0px;',
    flexWrap: 'nowrap',

    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  imagelistitem: {
    marginRight: '10px;',
  },
  paper: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    marginBottom: '20px;',
  },
  dialog: {
    overflowY: 'unset',
  },
  title: {
    color: theme.palette.primary.light,
    marginLeft: '0px;',
  },
  showImage: {
    height: '300px;',
    width: 'auto',
    opacity: '1',
  },
  button: {
    padding: 15,
  },
  link: {
    display: 'block',
    width: 333, 
    height: 250,
    padding: 15,
    marginRight: 15,
    overflow: 'hidden',
  }, 
  // titleBar: {
  //   background:
  //     'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
      
  // },
  // icon: {
  //   visibility: 'visible',
  //   backgroundColor: 'white',
  //   // backgroundColor: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  //   color: 'action',
  // },
  // chosen: {
  //   visibility: 'visible',
  //   backgroundColor: 'white',    
  // },
  // checkbox: {
  //   visibility: 'visible',
  //   backgroundColor: 'white',
  //   '&:hover': {
  //     backgroundColor: 'white',
  //   },
  //   color: "secondary",
  //   borderRadius: '0',
  //   padding: '5px;',
  // },
  // tooltip: {
  //   fontSize: '1rem',
  //   maxWidth: '600px;',
  //   backgroundColor: 'white',
  //   color: 'black',
  // },
  // formcontrol: {
  //   paddingLeft: '14px;'
  // },
}));

// const element = (item) => {
//   if(item === "https://via.placeholder.com/900x675") {
//     return <MyWindowPortal>
//               <h1>Counter in a portal: </h1>
//               <p>Even though I render in a different window, I share state!</p>
            
//             <button onClick={() => console.log('Portal')} >
//               Close me!
//             </button>
//             </MyWindowPortal>
//   } else {
//     return <img
//               width="900"
//               src={item} 
//               alt={item} 
//             />
//   }
// }

const _transformMpDetailSimple = (mpDetailSimple) => {
  if(mpDetailSimple.photos) {
    return mpDetailSimple.photos.map(item => {
      return {
          photo: item, 
          passport: mpDetailSimple.passport,
      }
    })
  }
  else {
    return      
  }
};

export default function MonitoringsPhotos(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {filteredMpDetails} = useSelector(state => state.mpDetails);
  const {selectedIndex, duplicatesFlag, filter} = useSelector(state => state.shared);

  const {item} = props;

  const arr = item 
    ? _transformMpDetailSimple(item)
    : [];

  const [open, setOpen] = useState(false);   // open fullWidth image

  const handleDoubleClick = (e) => {
    setOpen((prev) => !prev);
  };

  // const handlePopoverOpen = (e) => {
  //   setAnchorEl(e.currentTarget);
  // };

  // const handlePopoverClose = () => {
  //   setAnchorEl(null);
  // };

  // const openPopover = Boolean(anchorEl);
  // const id = openPopover ? 'simple-popover' : undefined;
  


  // if(filteredMpDetails.length !== filteredMpDetails.map(item => item.mprd_id).length) alert("Есть дубли по mprd_id");

  // let array;

  // if(selectedIndex === 2) {
  //   array = filteredMpDetails.filter(item => item.mprd_communication_id !== 0);
  // }
  // else if (selectedIndex === 3) {
  //   array = filteredMpDetails.filter(item => item.mprd_communication_id === 0);
  // }
  // else {
  //   array = filteredMpDetails;
  // }

  // if(duplicatesFlag == 'Yes') {
  //   const duplicates = filteredMpDetails.filter(item => item.mprd_communication_id !== 0);
  //   array = duplicates.reduce(function(acc, item, index, duplicates){
  //     const newArray = [...duplicates.slice(0,index), ...duplicates.slice(index+1)].map(item => item.mpc_name); 
  //     if(newArray.includes(item.mpc_name)) {
  //       return acc.concat(item)
  //     }
  //     else {
  //       return acc
  //     }
  //   }, []);
  // }  

  // console.log('filteredMpDetails: ', filteredMpDetails);
  console.log('item: ', item);
  console.log('arr: ', arr);


  return arr ? (
          <div className={classes.root}>
              <GridList className={classes.imageList} >              
                  {arr.map((el, index) => (
                  
                  <MonitoringsImage 
                      item={el}
                      key={index}
                      height={250} 
                      width={333} 
                  />
                
                ))}
                
              </GridList>
            
          </div>
       )
       : (
        (
          // <Button style={{width: 333, height: 250}}>
            <a
              target="_blank" 
              href={item.passport}
              rel="noopener noreferrer"
              className={classes.link}
            >  
              <Typography variant="h5" align="center" className={classes.button}>
                  Смотреть паспорт
                  <Typography variant="subtitle2" align="center">
                    {item.passport}
                  </Typography>
                </Typography>
            </a> 
          // </Button>
          )
       )
}